module.exports = __webpack_public_path__ + "static/media/office3.9ab1b882.jpg";